import { MatDialog } from '@angular/material/dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';

export class TransportRegistrationInstructionsController extends AbstractStepController {

  private dialogService: DialogService;
  nextControl = new StepControl();
  previousControl = new StepControl();

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === TerminalContextConstants.transportInstructionsValidityState) {
      this.nextControl.disabled = !contextChange.value;
    }
    if (contextChange.key === TerminalContextConstants.transportInstructionsDetailsShownState) {
        this.previousControl.disabled = contextChange.value;
    }
  }

  onRegisterToDashboardContext() {
    this.nextControl.disabled = this.dashboardContext.getContextValue(TerminalContextConstants.transportInstructionsValidityState)
      !== true;
    this.previousControl.disabled = this.dashboardContext.getContextValue(TerminalContextConstants.transportInstructionsDetailsShownState)
        === true;
  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('instructions started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {

    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(result => {
      if (result) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    this.previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
    this.previousControl.type = StepControlType.BUTTON_STROKED;
    this.previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
    this.previousControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.previous();
    };
    controls.push(this.previousControl);

    var spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    var spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    // tmc-yard.widgets.registration-terminal.button.finish-registration
    this.nextControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.next';
    this.nextControl.type = StepControlType.BUTTON;
    this.nextControl.iconAfterCss = 'fa-thin fa-angle-right';
    this.nextControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.next();
    };
    controls.push(this.nextControl);

    return controls;
  }
}
